import * as React from 'react';
import { Link } from 'react-router-dom';
import { css } from 'react-strict-dom';

type Props = Readonly<{
  to: string;
  children: React.ReactNode;
}>;

export default function AuthMessageLink({ to, children }: Props) {
  return (
    <Link to={to} {...css.props(styles.link)}>
      {children}
    </Link>
  );
}

const styles = css.create({
  link: {
    // Auth screens use a distinct brand blue; there is no design-system token.
    color: '#64adff',
    textDecorationLine: 'none',
  },
});
